import React from 'react';
const SvgFolderThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M18 20.45H6a3.6 3.6 0 01-3.6-3.6v-9.7A3.6 3.6 0 016 3.55h4.84a.71.71 0 01.53.22l2.12 2.1H18a3.61 3.61 0 013.6 3.61v7.37a3.6 3.6 0 01-3.6 3.6zM3.89 9.48v7.37A2.1 2.1 0 006 19h12a2.099 2.099 0 002.1-2.1V9.48A2.1 2.1 0 0018 7.37h-4.83a.75.75 0 01-.53-.22l-2.12-2.1H6a2.1 2.1 0 00-2.1 2.1l-.01 2.33z"
        fill="currentColor"
      />
    </svg>
  );
});
export default SvgFolderThumbnail;
SvgFolderThumbnail.iconName = 'folder-thumbnail';
SvgFolderThumbnail.displayName = 'SvgFolderThumbnail';
